/**
 * Life4Earth V2 — Feed Member Discovery API adapter
 * (HANDOFF_FEED_MEMBER_DISCOVERY, Slice B).
 *
 * The "Fellow members of {Org}" card surfaces members of the viewer's ORG
 * communities whom the viewer has no contact/follow edge with. The ONLY
 * selection signal is shared org membership — functional, not social.
 */

import { apiFetch } from "./client";

export interface FellowMemberCandidate {
  targetGuid: string;
  /** Full name (preferred label); falls back to displayName when empty. */
  name: string;
  displayName: string;
  screenName?: string | null;
  profileImageUrl: string;
  /** The shared org community that justifies surfacing this member. */
  orgEntityGuid: string;
  orgName: string;
  /** Binary trust ring: true = blue (rung basics done / sysadmin), false =
   * white. White for Explorer, blue for every rung above (Skip 2026-07-08). */
  ringActive: boolean;
}

/** Server records an impression (7-day cap) for each returned candidate. */
export function fetchFellowMembers(limit = 3): Promise<FellowMemberCandidate[]> {
  return apiFetch<FellowMemberCandidate[]>(`/api/discovery/fellow-members?limit=${limit}`);
}

/** "snooze" = 30-day "Not now"; "ignore" = permanent "Not interested". */
export function dismissDiscoveryCandidate(
  targetGuid: string,
  kind: "snooze" | "ignore",
): Promise<void> {
  return apiFetch<void>(`/api/discovery/dismiss`, {
    method: "POST",
    body: JSON.stringify({ targetGuid, kind }),
  });
}
